export default {

	props: {
		party: Number,
		canConsent: Boolean,
		sourceType: Number,
		buttonAgreeTitle: String,
		buttonDisagreeTitle: String,
		consentTitle: String,
		emptyTitle: String
	},
	data() {
		return {
			consent: 0,
			description: "",
			errorForm: "",
			errorProperty: "",
			consentList: []
		}
	},
	computed: {
		disabledButton() {
			return this.consentList.length===0;
		},
		isErrorForm() {
			return  this.errorForm !== null && this.errorForm !== undefined && this.errorForm.length>0;
		},
		isErrorProperty() {
			return  this.errorProperty !== null && this.errorProperty !== undefined && this.errorProperty.length>0;
		},
		isSelectedConsent() {
			return this.consent!==0;
		}
	},
	methods: {
		agreeConsent() {
			this.addConsent(true);
		},
		disagreeConsent() {
			this.addConsent(false);
		},
		addConsent(value) {
			this.errorForm="";
			if (this.consent===0) {
				this.errorProperty=this.emptyTitle;
			}
			else {
				this.errorProperty="";
				var data = {
				  "type": this.consent,
				  "source": this.sourceType,
				  "description": this.description,
				  "party": this.party,
				  "value": value
				}
				fetch("./api/consents", {
				  method: 'POST',
				  headers: { 'Content-Type': 'application/json; charset=utf-8' },
				  body: JSON.stringify(data)
				})
				.then(response => {
					if (response.ok) {
						//remove added campaign from list
						this.consent=0;
						this.description="";
						//refresh table
						this.$emit('refresh');
					}
					else {
						console.error('Error:', response.status);
						this.errorForm="RestApi point return status:"+response.status;
					}
				})
				.catch((error) => {
				  console.error('Error:', error);
				  this.errorForm="Error to fetch restApi point";
				});
			}
		},
		loadData() {
			this.consentList=[];
			return fetch("./api/lists/_cct?onlyEnabled=true")
			.then(response => response.json())
			.then(data => {
				if (data !== null && data !== undefined) {
					this.consentList=data.items;
				}
				else {
					console.log("Loaded consent's list is invalid");
					this.errorForm = "Loaded consent's list is invalid";
				}
			})
			.catch((error) => {
				console.log("Error loading consent's list:"+error);
				this.errorForm = error;
			});
		}
	},
	mounted() {
		this.loadData();
	},
	template:
`
<div v-if="isErrorForm && canConsent" class="errors">
	<span class="perr">{{errorForm}}</span>
</div>
<div class="grid consent-form" v-if="canConsent">
	<div class="gd" id="consent-form-select">
		<div><span class="fi"></span> {{consentTitle}}: 
			<select v-model.number="consent" tabindex='150'>
			  <option value="0">-</option>
			  <option v-for="item in consentList" :value="item.value">
				{{ item.name }}
			  </option>
			</select>
			<span v-if="isErrorProperty" class="perr">{{errorProperty}}</span>
		</div>
	</div>
	<div class="gd" id="consent-form-buttons">
		<button class="fbutton" style="--button-hue:0" @click="disagreeConsent" :disabled='disabledButton' tabindex='250'>{{buttonDisagreeTitle}}</button>
		<button class="fbutton" style="--button-hue:120" @click="agreeConsent" :disabled='disabledButton' tabindex='200'>{{buttonAgreeTitle}}</button>&nbsp;
	</div>
	<Transition name="consent-description" >
		<div class="gd" id="consent-form-desc" v-if="isSelectedConsent">
			<textarea v-model="description" cols='48' rows="2" tabindex='150' class="width100p"></textarea>
		</div>
	</Transition>
</div>`
}

